import { route } from "../../service/routeDictionary";
import API from "../../service/api";
import { environment } from "../../environments/env";

const state = {
  facebookUsers: {},
};

const getters = {
  facebookUsers: (state) => state.facebookUsers,
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async carregarPorFacebookUser({ commit }, usuario) {
    return await API.post(
      `${environment.apiUri}${route.CarregarPorFacebookUser}`,
      usuario
    );
  },
  // eslint-disable-next-line no-unused-vars
  async gravarInstagramPage({ commit }, data) {
    return await API.post(
      `${environment.apiUri}${route.GravarInstagramPage}`,
      data
    );
  },

  async atualizarToken({}, data) {
    return await API.post(
      `${environment.apiUri}${route.AtualizarTokenFacebookPage}`,
      data
    );
  },
};
const mutations = {};

export default {
  state,
  actions,
  getters,
  mutations,
};
